import { Converter } from '../types/converter';

export const surfaceCurrentDensityConverter: Converter = {
  id: 'surfaceCurrentDensity',
  name: 'Surface Current Density Converter',
  icon: 'Square',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Ampere/square meter', symbol: 'A/m²', factor: 1 },
    { name: 'Ampere/square centimeter', symbol: 'A/cm²', factor: 10000 },
    { name: 'Ampere/square inch', symbol: 'A/in²', factor: 1550.0031000062 },
    { name: 'Ampere/square mil', symbol: 'A/mi²', factor: 1550003100.0062 },
    { name: 'Ampere/circular mil', symbol: 'A/cmil', factor: 1973525249.7379 },
    { name: 'Abampere/square centimeter', symbol: 'abA/cm²', factor: 100000 }
  ]
};
